var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position"},[_c('el-cascader',{attrs:{"size":"medium","options":_vm.positions,"props":_vm.defaultProps},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }